import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BootstrapIsInvalidDirective } from './bootstrap-is-invalid.directive';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { PrimaryAddressPipe } from './primary-address.pipe';
import { ReplaceDashPipe } from './replace-dash.pipe';



@NgModule({
  declarations: [
    ReplaceDashPipe,
    PrimaryAddressPipe,
    BootstrapIsInvalidDirective,
    ConfirmModalComponent
  ],
  imports: [
    CommonModule,
    NgbModule
  ],
  exports: [
    ReplaceDashPipe,
    PrimaryAddressPipe,
    BootstrapIsInvalidDirective
  ]
})
export class SharedModule { }
